export const MAX_COUNT_ALL_URLS = 200;

export const BodyTypeEnum = Object.freeze({
  SEDAN: 'sedan',
  WAGON: 'wagon',
  SPORTBACK: 'sportback',
  SUV: 'suv',
  ELECTRIC: 'electric',
  SPORT: 'sport',
});

export const PricingEnum = Object.freeze({
  ENTRY: 'entry',
  MID: 'mid',
  PREMIUM: 'premium',
  LUXURY: 'luxury',
  SPORT: 'sport',
});

export const usaModelEntry = {
  a3: {
    heading: 'Audi A3',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/MY25---A3---Front---Driving---5679-592x925.jpg',
    category: PricingEnum.ENTRY,
    bodyType: [BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/a3/a3/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a3/a3/2025/overview/build/?ulid=1742569984579&pr=8YMBUY0_2025%7CZ9Z9%7CAO',
  },
  q3: {
    heading: 'Audi Q3',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-MY25-Q3-Exterior-Front-Profile-Parked-5982.jpg',
    category: PricingEnum.ENTRY,
    bodyType: [BodyTypeEnum.SUV],
    mlpUrl: 'https://www.audiusa.com/en/models/q3/q3/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q3/q3/2025/overview/build/?ulid=1742569994995&pr=F3BCEA0_2025%7CZ9Z9%7CML',
  },
};
export const usaModelMid = {
  'all-new-q5': {
    heading: 'Audi Q5',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_Q5_2024_6820_NoPlate.jpg',
    category: PricingEnum.MID,
    bodyType: [BodyTypeEnum.SUV],
    mlpUrl: 'https://www.audiusa.com/en/models/q5/all-new-q5/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q5/q5/2025/overview/build/?ulid=1742570024278&pr=FYGBZY0_2025%7CL5L5%7CEM',
  },
  'q4-e-tron': {
    heading: 'Audi Q4 e-tron',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_PCT_MY25---Q4-e-tron---Front-Profile---Parked---Pebble-Gray---003.jpg',
    category: PricingEnum.MID,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.ELECTRIC],
    mlpUrl: 'https://www.audiusa.com/en/models/q4/q4-e-tron/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q4/q4-e-tron/2025/overview/build/?ulid=1742570016373&pr=F4BA531_2025%7CC2C2%7CAO',
  },
  'q4-sportback-e-tron': {
    heading: 'Audi Q4 Sportback e-tron',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_MY25---Q4-Sportback-e-tron---Front-Profile---Parked---2544.jpg',
    category: PricingEnum.MID,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.SPORTBACK, BodyTypeEnum.ELECTRIC],
    mlpUrl: 'https://www.audiusa.com/en/models/q4/q4-sportback-e-tron/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q4/q4-sportback-e-tron/2025/overview/build/?ulid=1742570021144&pr=F4NAU31_2025%7CC2C2%7CAO',
  },
  'all-new-sq5': {
    heading: 'Audi SQ5',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-PCT-MY25-SQ5-Exterior-FrontProfile-Driving-6849.jpg',
    category: PricingEnum.MID,
    bodyType: [BodyTypeEnum.SUV],
    mlpUrl: 'https://www.audiusa.com/en/models/q5/all-new-sq5/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q5/sq5/2025/overview/build/?ulid=1742570026723&pr=FYGS4A0_2025%7CL5L5%7COQ',
  },
  'all-new-q5-sportback': {
    heading: 'Audi Q5 Sportback',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-PCT-MY25-Q5-Sportback-Exterior-Front-Profile-Parked-7165_v3.jpg',
    category: PricingEnum.MID,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.SPORTBACK],
    mlpUrl: 'https://www.audiusa.com/en/models/q5/all-new-q5-sportback/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q5/q5-sportback/2025/overview/build/?ulid=1742570029647&pr=FYTCAY0_2025%7CL5L5%7CBG',
  },
  'all-new-sq5-sportback': {
    heading: 'Audi SQ5 Sportback',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-PCT-MY25-SQ5-Sportback-Exterior-Front-Profile-Parked-7201.jpg',
    category: PricingEnum.MID,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.SPORTBACK],
    mlpUrl: 'https://www.audiusa.com/en/models/q5/all-new-sq5-sportback/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q5/sq5-sportback/2025/overview/build/?ulid=1742570032850&pr=FYTS4A0_2025%7CL5L5%7COQ',
  },
  'all-new-a5': {
    heading: 'Audi A5',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/MY25---A5---Exterior---Front-Profile---Driving---3-TILE-ONE-592x925.jpg',
    category: PricingEnum.MID,
    bodyType: [BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/a5/all-new-a5/2025/overview/',
    buildUrlFake: 'TODO BUILD URL',
  },
  'all-new-s5': {
    heading: 'Audi S5',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_D1_MY25---S5-Sedan---Exterior---Front-Profile---Parked---6272b.jpg',
    category: PricingEnum.MID,
    bodyType: [BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/a5/all-new-s5/2025/overview/',
    buildUrlFake: 'TODO BUILD URL',
  },
};
export const usaModelPremium = {
  'a6-sedan': {
    heading: 'Audi A6 Sedan',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-MY25---A6---Exterior---Front---Profile---Driving---4047.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/a6/a6-sedan/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a6/a6-sedan/2025/overview/build/?ulid=1742570035699&pr=4A2B3Y0_2025%7CL5L5%7CMN',
  },
  'a6-allroad': {
    heading: 'Audi A6 allroad',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_MY25---A6-allroad-quattro---Rear---Profile---Parked---0553.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.WAGON],
    mlpUrl: 'https://www.audiusa.com/en/models/a6/a6-allroad/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a6/a6-allroad/2025/overview/build/?ulid=1742570038300&pr=4AH02Y1MSNRS0D_2025%7CL5L5%7CMN',
  },
  's6-sedan': {
    heading: 'Audi S6 Sedan',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_MY25---S6---Exterior---Front---Profile---Parked---181006.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/a6/s6-sedan/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a6/s6-sedan/2025/overview/build/?ulid=1742570041257&pr=4A2SFA1MSNRS0D_2025%7CL5L5%7CMZ',
  },
  'a7-sportback': {
    heading: 'Audi A7',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_MY25---A7---Front-Profile--Parked---171022.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SEDAN, BodyTypeEnum.SPORTBACK],
    mlpUrl: 'https://www.audiusa.com/en/models/a7/a7-sportback/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a7/a7-sportback/2025/overview/build/?ulid=1742570043549&pr=4KA02Y1_2025%7CL5L5%7CMP',
  },
  's7-sportback': {
    heading: 'Audi S7',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-D2-MY25-S7-Rear-Profile-Driving-181003_3.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/a7/s7-sportback/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a7/s7-sportback/2025/overview/build/?ulid=1742570046022&pr=4KASFA1MSNRS0D_2025%7CL5L5%7CMZ',
  },
  'q6-e-tron': {
    heading: 'Audi Q6 e-tron',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/MY25---Q6-e-tron---Driving---3-TILE-THREE-592x925.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.ELECTRIC],
    mlpUrl: 'https://www.audiusa.com/en/models/q6-e-tron/q6-e-tron/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q6-e-tron/q6-e-tron/2025/overview/build/?ulid=1742570048688&pr=GFBA280_2025%7C2Y2Y%7CFW',
  },
  'sq6-e-tron': {
    heading: 'Audi SQ6 e-tron',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_V2_MY25---SQ6-e-tron---Front---Profile---Parked---5304.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.ELECTRIC],
    mlpUrl: 'https://www.audiusa.com/en/models/q6-e-tron/sq6-e-tron/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q6-e-tron/sq6-e-tron/2025/overview/build/?ulid=1742570051183&pr=GFBS580_2025%7CG5G5%7CGX',
  },
  q7: {
    heading: 'Audi Q7',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_landscape2_MY25---Q7---Front-Profile---Parked---5386.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SUV],
    mlpUrl: 'https://www.audiusa.com/en/models/q7/q7/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q7/q7/2025/overview/build/?ulid=1742570054024&pr=4MQAC10MSNRS0D_2025%7C0Q0Q%7CMP',
  },
  sq7: {
    heading: 'Audi SQ7',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_MY25---SQ7---Front-Profile---Parked---5418.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SUV],
    mlpUrl: 'https://www.audiusa.com/en/models/q7/sq7/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q7/sq7/2025/overview/build/?ulid=1742570056459&pr=4MQSW10MSNRS0D_2025%7C0Q0Q%7COQ',
  },
};
export const usaModelLuxury = {
  'a8-sedan': {
    heading: 'Audi A8',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-P1-MY25-A8-Exterior-Front-Profile-Driving-3279.jpg',
    category: PricingEnum.LUXURY,
    bodyType: [BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/a8/a8-sedan/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a8/a8-sedan/2025/overview/build/?ulid=1742570059426&pr=4NL5DA1MKZV6W9_2025%7CL5L5%7CWH%7CMEIH5MC',
  },
  's8-sedan': {
    heading: 'Audi S8',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-P3-MY25-S8-Exterior-Front-Profile-Parked-3261.jpg',
    category: PricingEnum.LUXURY,
    bodyType: [BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/a8/s8-sedan/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a8/s8-sedan/2025/overview/build/?ulid=1742570062642&pr=4NL5SA0MSNRS0DMKZV6W9_2025%7CL5L5%7CWY',
  },
  q8: {
    heading: 'Audi Q8',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592-925_MY25---Q8---Exterior---Front-Profile---Driving---5485.jpg',
    category: PricingEnum.LUXURY,
    bodyType: [BodyTypeEnum.SUV],
    mlpUrl: 'https://www.audiusa.com/en/models/q8/q8/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q8/q8/2025/overview/build/?ulid=1742570065453&pr=4MT5X20MSNRS0D_2025%7C0Q0Q%7CMP',
  },
  sq8: {
    heading: 'Audi SQ8',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_MY25---SQ8---Exterior---Front---Profile---Driving---5513.jpg',
    category: PricingEnum.LUXURY,
    bodyType: [BodyTypeEnum.SUV],
    mlpUrl: 'https://www.audiusa.com/en/models/q8/sq8/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q8/sq8/2025/overview/build/?ulid=1742570068832&pr=4MT5W10MSNRS0D_2025%7C0Q0Q%7COQ',
  },
  's-e-tron-gt': {
    heading: 'Audi e-tron GT',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-Stage-MY25-Se-tronGT-Exterior-FrontProfile-Parked-6507.jpg',
    category: PricingEnum.LUXURY,
    bodyType: [BodyTypeEnum.ELECTRIC, BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/e-tron-gt/s-e-tron-gt/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/e-tron-gt/s-e-tron-gt/2025/overview/build/?ulid=1742570071018&pr=F8PR9D0_2025%7CL5L5%7CJN',
  },
};
export const usaModelSport = {
  'rs3-sedan': {
    heading: 'Audi RS 3',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-P3-MY25-RS3-Exterior-FrontProfile-Driving-6174.jpg',
    category: PricingEnum.SPORT,
    bodyType: [BodyTypeEnum.SEDAN, BodyTypeEnum.SPORT],
    mlpUrl: 'https://www.audiusa.com/en/models/a3/rs3-sedan/2024/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a3/rs3-sedan/2024/overview/build/?ulid=1742570073502&pr=8YSR4Y0MSNRS0D_2024%7C7R7R%7CQW',
  },
  'rs6-avant': {
    heading: 'Audi RS 6 Avant Performance',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_MY25---RS-6-Avant-performance---Front---Profile---Parked---4339.jpg',
    category: PricingEnum.SPORT,
    bodyType: [BodyTypeEnum.WAGON, BodyTypeEnum.SPORT],
    mlpUrl: 'https://www.audiusa.com/en/models/a6/rs6-avant/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a6/rs6-avant/2025/overview/build/?ulid=1742570082109&pr=4A5RRA0MSNRS0D_2025%7CL5L5%7CMA',
  },
  rs7: {
    heading: 'Audi RS 7 Performance',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-P1-MY25-RS-7-performance-Front-Profile-Driving-4359.jpg',
    category: PricingEnum.SPORT,
    bodyType: [BodyTypeEnum.SPORTBACK, BodyTypeEnum.SPORT],
    mlpUrl: 'https://www.audiusa.com/en/models/a7/rs7/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/a7/rs7/2025/overview/build/?ulid=1742570085006&pr=4KARRA0MSNRS0D_2025%7CL5L5%7CMA',
  },
  rsq8: {
    heading: 'Audi RS Q8 Performance',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_MY25---RS-Q8-performance---Exterior---Front-Profile---Driving---6667.jpg',
    category: PricingEnum.SPORT,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.SPORT],
    mlpUrl: 'https://www.audiusa.com/en/models/q8/rsq8/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/q8/rsq8/2025/overview/build/?ulid=1742570087210&pr=4MTRR20MSNRS0D_2025%7C0Q0Q%7CUB',
  },
  'rs-e-tron-gt': {
    heading: 'Audi RS e-tron GT Performance',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-P3-MY25-RSe-tronGTperformance-Exterior-Front-Profile-Driving-6587.jpg',
    category: PricingEnum.SPORT,
    bodyType: [BodyTypeEnum.SPORT, BodyTypeEnum.ELECTRIC, BodyTypeEnum.SEDAN],
    mlpUrl: 'https://www.audiusa.com/en/models/e-tron-gt/rs-e-tron-gt/2025/overview/',
    buildUrlFake:
      'https://www.audiusa.com/en/models/e-tron-gt/rs-e-tron-gt/2025/overview/build/?ulid=1742570090038&pr=F8PR8D0_2025%7CL5L5%7CFO',
  },
  'q6-sportback-e-tron': {
    heading: 'Audi Q6 Sportback e-tron',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_STAGE_MY25---Q6-Sportback-e-tron---Exterior---Front-Profile---Parked---5211b.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.SPORTBACK, BodyTypeEnum.ELECTRIC],
    mlpUrl: 'https://www.audiusa.com/en/models/q6-e-tron/q6-sportback-e-tron/2025/overview/',
    buildUrlFake: 'TODO BUILD URL',
  },
  'sq6-sportback-e-tron': {
    heading: 'Audi SQ6 Sportback e-tron',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925_P4_MY25---SQ6-Sportback-e-tron---Exterior---Rear-Profile---Parked---5338.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SUV, BodyTypeEnum.SPORTBACK, BodyTypeEnum.ELECTRIC],
    mlpUrl: 'https://www.audiusa.com/en/models/q6-e-tron/sq6-sportback-e-tron/2025/overview/',
    buildUrlFake: 'TODO BUILD URL',
  },
  'a6-sportback-e-tron': {
    heading: 'Audi A6 Sportback e-tron',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/MY25---A6-Sportback-e-tron---Exterior---Front-Profile---Driving---3-TILE-TWO-592x925.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SPORTBACK, BodyTypeEnum.ELECTRIC],
    mlpUrl: 'https://www.audiusa.com/en/models/a6/a6-sportback-e-tron/2025/overview/',
    buildUrlFake: 'TODO BUILD URL',
  },
  's6-sportback-e-tron': {
    heading: 'Audi S6 Sportback e-tron',
    imageSmall:
      'https://nar.media.audi.com/is/image/audinar/country/us/en/assets/pct/592x925-P3-MY25-S6-Sportback-e-tron-Exterior-Front-Profile-Driving-6069.jpg',
    category: PricingEnum.PREMIUM,
    bodyType: [BodyTypeEnum.SPORTBACK, BodyTypeEnum.ELECTRIC],
    mlpUrl: 'https://www.audiusa.com/en/models/a6/s6-sportback-e-tron/2025/overview/',
    buildUrlFake: 'TODO BUILD URL',
  },
};
export const audiUSAModelRegistry = {
  ...usaModelEntry,
  ...usaModelMid,
  ...usaModelPremium,
  ...usaModelLuxury,
  ...usaModelSport,
};

export const organizedModelPriceMapping = Object.values(audiUSAModelRegistry).reduce(
  (acc, model) => {
    model.bodyType.forEach((bodyType) => {
      if (!acc[bodyType]) {
        acc[bodyType] = {};
      }

      const { category } = model;
      if (!acc[bodyType][category]) {
        acc[bodyType][category] = [];
      }

      // eslint-disable-next-line no-useless-escape
      const modelNameMatch = model.mlpUrl.match(/models\/(?:[^\/]+\/)?([^\/]+)\//);
      const modelName = modelNameMatch ? modelNameMatch[1] : '';

      acc[bodyType][category].push({
        modelName,
        bodyType: model.bodyType,
        url: model.mlpUrl,
        model,
      });
    });
    return acc;
  },
  {},
);

export const AEMModelAssets = Object.keys(audiUSAModelRegistry).reduce((acc, model) => {
  const { heading } = audiUSAModelRegistry[model];
  acc[model] = heading.replace(/^Audi /, '');
  return acc;
}, {});

export const getPriceRowMacthes = (pricingCategory) => {
  const matches = [];
  for (const key of Object.keys(audiUSAModelRegistry)) {
    const { category, bodyType, mlpUrl, buildUrlFake } = audiUSAModelRegistry[key];
    if (category === pricingCategory) {
      const data = { name: key, category, bodyType, mlpUrl, buildUrlFake };
      matches.push(data);
    }
  }
  return matches;
};

export const getAllPriceRowMatches = () => {
  const toReturn = Object.values(PricingEnum).map((pricingCategory) => {
    return getPriceRowMacthes(pricingCategory);
  });
  return toReturn;
};
